import Header from "../Components/Header";
import styles from "../styles/Blog.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Grid2 } from "@mui/material";
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import Agendar from "../Components/Agendar";
import Footer from "../Components/Footer";

const Blog = () => {
    const [posts, setPosts] = useState([]);
    useEffect(() => {
        axios.get("https://api.sigmasystems.com.br/api/odontoluzzi/get-posts")
          .then((res) => {
            setPosts(res.data);
          })
          .catch((err) => {
            console.error("Erro ao buscar posts:", err);
          });
    }, []);

    return(
        <div className="container">
            <Header/>
            <div className="content">             
                <div className="blogContainer">
                    <div className="blogContent">
                        <div className="subTitle from-top">Blog</div>
                        <div className="title depo from-top">Veja as novidades</div>
                        <div className="titleLine from-top"/>
                        <div className="blogList from-bottom">
                        <Grid2 columns={{ xs:4, sm:8, md:12}} container spacing={2} justifyContent={'left'}>
                                <Grid2 item>
                                    <Grid2 container className='from-bottom' justifyContent={'left'} spacing={3} width={'100%'} marginLeft={0}>
                                    {posts.map((post) => (
                                        
                                        <div key={post.id} className={`blogCard`}>
                                            {post?.foto ? <img className="postFoto" src={`https://api.sigmasystems.com.br/api/odontoluzzi/uploads/blog/${post.foto}`}/> : <img className="postFoto" src={"https://odontoluzzi.com.br/images/padrao/padraoBlog.png"}/>}
                                            <div className="blogCardRight">
                                                <div className="blogDataPost">
                                                    <CalendarTodayRoundedIcon sx={{color:'#B08E44'}}/>
                                                    <div className="data">{post.dataFormatada}</div>
                                                </div>
                                                
                                                <h2 className="blogTitulo">{post.titulo}</h2>
                                                <div className="blogText">
                                                    <p>{post.text.substring(0, 250)}...</p>
                                                </div>
                                                <div className="titleLine linePost" style={{width:100, marginBottom:15}}/>
                                                <Link className="blogLink" to={`/Blog/${post.id}`}>{'Leia mais >>'}</Link>
                                            </div>
                                        </div>
                                    ))}
                                </Grid2>                    
                            </Grid2>
                        </Grid2>
                        </div>
                    </div>
                </div>
                <Agendar/>
                <Footer/>
            </div>
        </div>
    )
}
export default Blog;